const _temp0 = require("./ckeditor.styl");
const _temp1 = require("./daterangepicker.styl");
const _temp2 = require("./izitoast.styl");
const _temp3 = require("./jfilestyle.styl");
const _temp4 = require("./pretty-checkbox.styl");
const _temp5 = require("./remodal.styl");
const _temp6 = require("./select2.styl");
const _temp7 = require("./splide.styl");
const _temp8 = require("./sweetalert2.styl");
const _temp9 = require("./tablefilter.styl");
const _temp10 = require("./tablesorter.styl");
module.exports = {
  "ckeditor": _temp0,
  "daterangepicker": _temp1,
  "izitoast": _temp2,
  "jfilestyle": _temp3,
  "pretty-checkbox": _temp4,
  "remodal": _temp5,
  "select2": _temp6,
  "splide": _temp7,
  "sweetalert2": _temp8,
  "tablefilter": _temp9,
  "tablesorter": _temp10
}